(function () {

  // ─── 共通ユーティリティ ───────────────────────────────────────────

  /**
   * 有効なmax値を計算する
   * effectiveMax = min(metafield_max, inventory - cartQty)
   * inventory_management が 'shopify' 以外の場合は在庫制限なし
   */
  function calcEffectiveMax(limitsEl, cartQty) {
    const metafieldMax = limitsEl.dataset.max !== '' ? parseInt(limitsEl.dataset.max, 10) : null;
    const inventory    = parseInt(limitsEl.dataset.inventory || '-1', 10);
    const policy       = limitsEl.dataset.inventoryPolicy || '';

    let inventoryBasedMax = null;
    if (policy === 'shopify' && inventory >= 0) {
      inventoryBasedMax = Math.max(0, inventory - cartQty);
    }

    if (metafieldMax !== null && inventoryBasedMax !== null) {
      return Math.min(metafieldMax, inventoryBasedMax);
    } else if (metafieldMax !== null) {
      return metafieldMax;
    } else if (inventoryBasedMax !== null) {
      return inventoryBasedMax;
    }
    return null; // 上限なし
  }

  // ─── 商品ページ: カートに追加時のバリデーション ──────────────────

  document.addEventListener(
    'submit',
    function (e) {
      const form = e.target;
      if (!form.matches('[data-type="add-to-cart-form"]')) return;

      const limitsEl = document.querySelector('#product-qty-limits');
      if (!limitsEl) return;

      const qtyInput = form.querySelector('input[name="quantity"]') ||
                       document.querySelector('input[name="quantity"]');
      if (!qtyInput) return;

      const addingQty = parseInt(qtyInput.value, 10);
      const cartQty   = parseInt(qtyInput.dataset.cartQuantity || '0', 10);

      const min         = parseInt(limitsEl.dataset.min, 10);
      const effectiveMax = calcEffectiveMax(limitsEl, cartQty);

      let errorMsg = null;

      // 最小数量チェック
      if (addingQty < min && cartQty === 0) {
        errorMsg = `数量は ${min} 以上で入力してください。`;
      }
      // 最大数量チェック（addingQty と残り可能数を比較）
      else if (effectiveMax !== null && addingQty > effectiveMax) {
        if (effectiveMax <= 0) {
          errorMsg = cartQty > 0
            ? `在庫がありません。（現在カート内: ${cartQty}個）`
            : '在庫がありません。';
        } else {
          errorMsg = `あと ${effectiveMax}個までしか追加できません。（現在カート内: ${cartQty}個）`;
        }
      }

      if (errorMsg) {
        e.preventDefault();
        e.stopImmediatePropagation();
        showProductError(errorMsg);
      }
    },
    true
  );

  function showProductError(msg) {
    const errorWrapper = document.querySelector('.product-form__error-message-wrapper');
    const errorMessage = document.querySelector('.product-form__error-message');
    if (errorWrapper && errorMessage) {
      errorMessage.textContent = msg;
      errorWrapper.removeAttribute('hidden');
    } else {
      alert(msg);
    }
  }

  // カートドロワー: キーボード入力のリアルタイム補正
  document.addEventListener('input', function (e) {
    const input = e.target;
    if (!input.matches('.cart-quantity input[name="updates[]"]')) return;

    const min      = parseInt(input.dataset.min || input.min || '1', 10);
    const max      = input.dataset.max ? parseInt(input.dataset.max, 10) : null;
    const inventory = parseInt(input.dataset.inventory || '-1', 10);
    const policy   = input.dataset.inventoryPolicy || '';
    let val = parseInt(input.value, 10);

    if (isNaN(val)) return;

    if (val < min) {
      input.value = String(min);
    } else if (max !== null && val > max) {
      input.value = String(max);
    } else if (policy === 'shopify' && inventory >= 0 && val > inventory) {
      input.value = String(inventory);
    }
  });

  // ─── 数量inputへの制限適用 ────────────────────────────────────────

  function applyQtyLimits(qtyInput) {
    const limitsEl = document.querySelector('#product-qty-limits');
    if (!limitsEl) return;

    const min      = parseInt(limitsEl.dataset.min, 10);
    const cartQty  = parseInt(qtyInput.dataset.cartQuantity || '0', 10);
    const effectiveMax = calcEffectiveMax(limitsEl, cartQty);
    const effectiveMin = cartQty > 0 ? 1 : min;

    // min を更新
    qtyInput.min = String(effectiveMin);
    qtyInput.dataset.min = String(effectiveMin);

    // max を更新
    if (effectiveMax !== null) {
      const remaining = effectiveMax;
      qtyInput.max = String(remaining);
      qtyInput.dataset.max = String(remaining);
      if (parseInt(qtyInput.value) > remaining) {
        qtyInput.value = String(remaining);
      }
    } else {
      // 上限なし → max属性を削除
      qtyInput.removeAttribute('max');
      delete qtyInput.dataset.max;
    }

    // value を effectiveMin に補正
    if (parseInt(qtyInput.value) < effectiveMin) {
      qtyInput.value = String(effectiveMin);
    }

    // カートに追加ボタンの制御
    const submitBtn = document.querySelector('[data-type="add-to-cart-form"] [type="submit"]');
    if (submitBtn) {
      const btnText = submitBtn.querySelector('span:not(.visually-hidden):not(.sold-out-message)');
      const isMaxReached = effectiveMax !== null && effectiveMax <= 0;

      if (isMaxReached) {
        submitBtn.setAttribute('aria-disabled', 'true');
        submitBtn.classList.add('disabled');
        if (btnText) btnText.textContent = '上限に達しました';
      } else {
        submitBtn.removeAttribute('aria-disabled');
        submitBtn.classList.remove('disabled');
        if (btnText) {
          btnText.textContent =
            window.variantStrings?.addToCart ||
            document.querySelector('[data-type="add-to-cart-form"] [type="submit"] .visually-hidden')?.textContent ||
            'カートに追加';
        }
      }
    }

    // QuantityInputのvalidateQtyRulesを再実行
    const quantityInputEl = qtyInput.closest('quantity-input');
    if (quantityInputEl && typeof quantityInputEl.validateQtyRules === 'function') {
      quantityInputEl.validateQtyRules();
    }
  }

  // ─── バリアント切り替え時に在庫データを更新 ──────────────────────

  document.addEventListener('variant:change', function (e) {
    const variant  = e.detail?.variant;
    const limitsEl = document.querySelector('#product-qty-limits');
    if (!limitsEl || !variant) return;

    // 在庫データを新バリアントの値で更新
    limitsEl.dataset.inventory       = variant.inventory_quantity ?? -1;
    limitsEl.dataset.inventoryPolicy = variant.inventory_management ?? '';

    // 制限を再適用
    const qtyInput = document.querySelector('input[name="quantity"]');
    if (qtyInput) applyQtyLimits(qtyInput);
  });

  // ─── MutationObserver で data-cart-quantity の変化を監視 ─────────

  function observeCartQuantity() {
    const qtyInput = document.querySelector('input[name="quantity"]');
    if (!qtyInput) return;

    // 初回適用
    applyQtyLimits(qtyInput);

    // data-cart-quantity の変化を監視
    const observer = new MutationObserver(function () {
      applyQtyLimits(qtyInput);
    });
    observer.observe(qtyInput, {
      attributes: true,
      attributeFilter: ['data-cart-quantity']
    });

    // ★ 追加: キーボード入力・直接入力の補正
    qtyInput.addEventListener('change', function () {
      const limitsEl = document.querySelector('#product-qty-limits');
      if (!limitsEl) return;

      const cartQty    = parseInt(qtyInput.dataset.cartQuantity || '0', 10);
      const min        = parseInt(limitsEl.dataset.min, 10) || 1;
      const effectiveMax = calcEffectiveMax(limitsEl, cartQty);
      let val = parseInt(qtyInput.value, 10);

      if (isNaN(val) || val < min) {
        qtyInput.value = String(min);
      } else if (effectiveMax !== null && val > effectiveMax) {
        qtyInput.value = String(effectiveMax);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeCartQuantity);
  } else {
    observeCartQuantity();
  }
})();

// cart-drawer.liquidの<input class="quantity__input">のタグ内のstep=より前の箇所に以下の2行を追加
// data-inventory="{{ item.variant.inventory_quantity }}"
// data-inventory-policy="{{ item.variant.inventory_management }}"